export const VOLUNTEER = {
  // landing
  ctaSignup: "landing-signup-cta",
  ctaPartner: "landing-partner-cta",
  loginGoogle: "login-google-btn",
  loginDev: "login-dev-btn",
  // onboarding
  onboardingIndividual: "onboarding-type-individual",
  onboardingOrg: "onboarding-type-organisation",
  onboardingNext: "onboarding-next",
  onboardingSubmit: "onboarding-submit",
  onboardingOrgName: "onboarding-org-name",
  onboardingBio: "onboarding-bio",
  onboardingLocation: "onboarding-location",
  onboardingValueChip: (v) => `onboarding-value-${v}`,
  onboardingSkillChip: (s) => `onboarding-skill-${s}`,
  // nav
  navOpportunities: "nav-opportunities",
  navDashboard: "nav-dashboard",
  navCalendar: "nav-calendar",
  navMessages: "nav-messages",
  navBadges: "nav-badges",
  navLogout: "nav-logout",
  navProfileMenu: "nav-profile-menu",
  // opportunities
  oppSearch: "opp-search",
  oppFilterValue: "opp-filter-value",
  oppFilterSkill: "opp-filter-skill",
  oppCard: (id) => `opp-card-${id}`,
  oppApplyBtn: "opp-apply-btn",
  // create opp
  newOppTitle: "new-opp-title",
  newOppDesc: "new-opp-desc",
  newOppLocation: "new-opp-location",
  newOppHours: "new-opp-hours",
  newOppDate: "new-opp-date",
  newOppSubmit: "new-opp-submit",
  newOppOpenBtn: "new-opp-open-btn",
  // hours log
  logHoursOpenBtn: "log-hours-open-btn",
  logHoursOrg: "log-hours-org",
  logHoursOpp: "log-hours-opp",
  logHoursAmount: "log-hours-amount",
  logHoursNarrative: "log-hours-narrative",
  logHoursDate: "log-hours-date",
  logHoursSubmit: "log-hours-submit",
  // org actions
  approveBtn: (id) => `approve-${id}`,
  rejectBtn: (id) => `reject-${id}`,
  // messages
  msgThread: (id) => `msg-thread-${id}`,
  msgInput: "msg-input",
  msgSend: "msg-send",
  // certificate
  certPrintBtn: "cert-print-btn",
};
